// extracted by mini-css-extract-plugin
module.exports = {"PlayerWrapper":"VideoPlayer_PlayerWrapper__1LltN","PreviousLink":"VideoPlayer_PreviousLink__3TNCv"};